module.exports = __webpack_public_path__ + "components/ServicesCategories/icons/zezwolenia.svg?f8ba2338";


//////////////////
// WEBPACK FOOTER
// ./components/ServicesCategories/icons/zezwolenia.svg
// module id = 1883
// module chunks = 0